var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "56px",
    viewBox: "0 0 68 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "38109DC7-DD5D-435E-BF79-A7C0F2578B39") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 55.0819672 66.7933115 55.0819672 66.7933115 0.101901639 0 0.101901639"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JN-Generation-Letter---Concepts-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Page--Image-Updated-v1-Alt-New-Copy-2",
    transform: "translate(-805.000000, -286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Condo-Image-Alt1",
    transform: "translate(75.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(456.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(250.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 23.3117902,
    y1: 20.3360787,
    x2: 43.6691672,
    y2: 20.3360787,
    id: "Stroke-1",
    stroke: "#05314D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 0.816498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9425836,32.060459 C24.9425836,35.7766557 22.3160918,38.7896393 19.074518,38.7896393 C15.8338623,38.7896393 13.2064525,35.7766557 13.2064525,32.060459 C13.2064525,28.3442623 15.8338623,25.3303607 19.074518,25.3303607 C22.3160918,25.3303607 24.9425836,28.3442623 24.9425836,32.060459 Z",
    id: "Stroke-2",
    stroke: "#05314D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2951607,45.129941 C27.2488656,41.3852852 23.2737836,38.8460066 18.7065705,38.8460066 L18.6698492,38.8460066 C13.9888,38.8460066 9.93109508,41.5138098 7.9325377,45.410859",
    id: "Stroke-4",
    stroke: "#05314D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.6952918,
    y1: 34.9378492,
    x2: 56.3826361,
    y2: 34.9378492,
    id: "Stroke-6",
    stroke: "#05314D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.6952918,
    y1: 28.3565639,
    x2: 52.6352262,
    y2: 28.3565639,
    id: "Stroke-8",
    stroke: "#05314D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.6952918,
    y1: 41.5192262,
    x2: 53.5872262,
    y2: 41.5192262,
    id: "Stroke-10",
    stroke: "#05314D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-12",
    stroke: "#05314D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "27.2288525 19.4411803 39.7508197 19.4411803 39.7508197 1.24944262 27.2288525 1.24944262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1693115,13.6133246 L61.8653115,13.6133246 C63.9446557,13.6133246 65.6457705,15.3144393 65.6457705,17.3937836 L65.6457705,50.1547016 C65.6457705,52.2331279 63.9446557,53.9342426 61.8653115,53.9342426 L4.928,53.9342426 C2.84865574,53.9342426 1.14754098,52.2331279 1.14754098,50.1547016 L1.14754098,17.3937836 C1.14754098,15.3144393 2.84865574,13.6133246 4.928,13.6133246 L22.8250492,13.6133246",
    id: "Stroke-14",
    stroke: "#05314D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1913574,6.26006557 C31.6237508,5.67160656 32.3196197,5.28970492 33.1054557,5.28970492 C34.4164066,5.28970492 35.4785705,6.35278689 35.4785705,7.66281967 C35.4785705,8.31829508 35.213259,8.9122623 34.7836197,9.34098361",
    id: "Stroke-15",
    stroke: "#05314D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18);
export default __webpack_public_path__ + "static/media/Group 18.346c040672edd7d80c71f7a99046371f.svg";
export { ForwardRef as ReactComponent };